// Subscription feature flag keys.
//
// Companion to the BE shape in services/shared/shared_layer/schemas/subscription.py
// (UNIFIED_FEATURE_JSON / PLUS_FEATURE_JSON). Use these constants with
// useSubscriptionFeatures().hasFeature(...) so we never typo a dotted path.
//
// All flag-key strings are dotted paths into subscription.subscriptionType.feature.
// The BE persists the same JSON shape; this file is the FE-side mirror.
//
// RBAC is unchanged: subscription gating layers on top of permissions. A
// feature hidden by RBAC stays hidden. A feature visible by RBAC may become
// disabled (greyed out) if the tenant's plan does not include it.

export const SUB_FEATURES = {
  // Whole-module flags
  CRM: "modules.crm",
  INTERIOR_DESIGNER: "modules.interior_designer",

  // Project Detail tabs
  PROJECT_DOCUMENTS: "project_tabs.documents",
  PROJECT_WHATSAPP_TEMPLATES: "project_tabs.whatsapp_templates",
  PROJECT_CHANNEL_PARTNERS: "project_tabs.channel_partners",

  // Sales-area surfaces
  LEADS_MUTATION: "sales.leads_mutation",         // add/delete lead from developer view
  CUSTOMER_DOCUMENTS: "sales.customer_documents", // generate booking letter / demand letter / etc.

  // Profile
  ONBOARDING_STEPS: "profile.onboarding_steps",

  // Reports
  REPORTS_PROGRESS: "reports.progress",
  REPORTS_SALES: "reports.sales",

  // Approvals
  APPROVALS_DESIGN: "approvals.design",
  APPROVALS_CRM: "approvals.crm",

  // Dashboard widget groups
  DASHBOARD_ID_WIDGETS: "dashboard.id_widgets",
  DASHBOARD_CRM_WIDGETS: "dashboard.crm_widgets",

  // Notifications (governs cron skips + queue processor — mostly BE-relevant,
  // exposed here for completeness)
  NOTIFICATIONS_DEVELOPER_TO_BUYER: "notifications.developer_to_buyer",
};

// Default copy shown by <DisabledWithTooltip> when a feature is gated off.
export const FEATURE_GATE_TOOLTIP = "Available on BuildVizer Unified";
